<template>
	<HFWrapper @isNewUi="v => setNewUiflag(v)">
		<div v-bind:class="['rtr_' + currentRoute, 'pc_wrap', { sub_page, terms }]">
			<div v-if="!isNewUi">
				<Header v-if="!menuChange">
					<menu-routes
						:key="$route"
						:items="logged_in_gnb_items"
						:class="{ menu_area: false }"
						@showMerchantPicker="merchantSelectModal = true"
					></menu-routes>
				</Header>
				<HeaderM v-else></HeaderM>
			</div>
			<router-view></router-view>
			<div v-if="!isNewUi" class="copyright">
				{{ $t('new_ui.components.footer_component.copyright.text') }}
			</div>
		</div>
		<ModalView
			add-class="merchant"
			v-if="merchantSelectModal"
			@closeModal="merchantSelectModal = false"
		>
			<MerchantPicker
				@selectMerchant="selectMerchant"
				@closeModal="merchantSelectModal = false"
			></MerchantPicker>
		</ModalView>
	</HFWrapper>
</template>

<script>
import Header from '@/components/Layout/Header';
import HeaderM from '@/components/Layout/Header.m';
import MenuRoutes from '@/components/Menu/Routes.vue';
import { mapGetters } from 'vuex';
import ModalView from '@/components/Layout/ModalView';
import { defineAsyncComponent } from 'vue';
import HFW from '../../components/NewUi/Layout/HFW.vue';

export default {
	name: 'Layout',
	props: {
		sub_page: {
			default: false,
			type: Boolean,
		},
		terms: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			merchantSelectModal: false,
			gnb_items: [
				{
					name: 'personal',
					title: 'menu.personal',
					children: [
						{
							title: 'menu.personal-how',
							children: [
								{
									name: 'personal-how-online_shopping',
									title: 'menu.personal-how-online_shopping',
								},
								{
									name: 'personal-how-offline_kiosk',
									title: 'menu.personal-how-offline_kiosk',
								},
								{ name: 'personal-how-qr', title: 'menu.personal-how-qr' },
								{
									name: 'personal-how-jpworldpay_creditcard',
									title: 'menu.personal-how-jpworldpay_creditcard',
								},
								{
									name: 'personal-how-trade_and_cashback',
									title: 'menu.personal-how-trade_and_cashback',
								},
							],
						},
						{
							title: 'menu.personal-request',
							children: [
								{
									name: 'personal-request-send',
									title: 'menu.personal-request-send',
								},
								{
									name: 'personal-request-receive',
									title: 'menu.personal-request-receive',
								},
								{
									name: 'personal-request-deposit',
									title: 'menu.personal-request-deposit',
								},
								{
									name: 'personal-request-commission',
									title: 'menu.personal-request-commission',
								},
							],
						},
						{
							title: 'menu.personal-asset',
							children: [
								{
									name: 'personal-asset-wallet',
									title: 'menu.personal-asset-wallet',
								},
								{
									name: 'personal-asset-account',
									title: 'menu.personal-asset-account',
								},
								{
									name: 'personal-asset-jpys',
									title: 'menu.personal-asset-jpys',
								},
								{
									name: 'personal-asset-sale',
									title: 'menu.personal-asset-sale',
								},
								{
									name: 'personal-asset-exchange',
									title: 'menu.personal-asset-exchange',
								},
							],
						},
					],
				},
				{
					name: 'business',
					title: 'menu.business',
					children: [
						{
							title: 'menu.business-how',
							children: [
								{
									name: 'business-how-start',
									title: 'menu.business-how-start',
								},
								{
									name: 'business-how-receive',
									title: 'menu.business-how-receive',
								},
								{ name: 'business-how-pay', title: 'menu.business-how-pay' },
								{ name: 'business-how-risk', title: 'menu.business-how-risk' },
							],
						},
						{
							title: 'menu.business-operation',
							children: [
								{
									name: 'business-operation-corps',
									title: 'menu.business-operation-corps',
								},
								{
									name: 'business-operation-platform',
									title: 'menu.business-operation-platform',
								},
								{
									name: 'business-operation-pay',
									title: 'menu.business-operation-pay',
								},
								{
									name: 'business-operation-global',
									title: 'menu.business-operation-global',
								},
							],
						},
						{
							title: 'menu.business-asset',
							children: [
								{
									name: 'business-asset-pay',
									title: 'menu.business-asset-pay',
								},
							],
						},
					],
				},
				{ name: 'development', title: 'menu.development' },
				{ name: 'cs', title: 'menu.cs' },
			],
			logged_in_gnb_items: [
				{
					title: 'menu.pay',
					name: 'pay-payment',
					children: [
						{ name: 'pay-payment', title: 'menu.pay-payment' },
						{ name: 'pay-deposit', title: 'menu.pay-deposit' },
						{ name: 'pay-exchange', title: 'menu.pay-exchange' },
						{ name: 'pay-c2c', title: 'menu.pay-c2c' },
						// { name: 'pay-contacts', title: 'menu.pay-contacts' },
					],
				},
				// {
				// 	title: 'menu.wallet_account',
				// 	name: 'wallet_account-assets',
				// },
				{
					title: 'menu.activity-transaction',
					name: 'activity',
					children: [
						{ name: 'activity', title: 'menu.activity-transaction' },
						{ name: 'activity-exchange', title: 'menu.activity-exchange' },
						{ name: 'activity-c2c', title: 'menu.activity-c2c' },
						// { name: 'activity-invoice', title: 'menu.activity-invoice' },
					],
				},
				{
					title: 'menu.cs',
					name: 'user-inquiry',
					children: [
						{ name: 'user-notice', title: 'menu.notice' },
						{ name: 'user-inquiry', title: 'menu.inquiry' },
						{ name: 'user-inquiry_list', title: 'menu.inquiry_detail' },
						{ name: 'user-faq', title: 'menu.faq' },
					],
				},
				{
					name: 'merchant-picker',
					title: 'menu.merchant.merchant',
				},
			],
			menuChange: window.innerWidth < 768,
			isNewUi: false,
		};
	},
	components: {
		Header,
		HeaderM,
		MenuRoutes,
		ModalView,
		MerchantPicker: defineAsyncComponent(() =>
			import('@/components/Merchant/MerchantPicker.vue'),
		),
		HFWrapper: HFW,
	},
	computed: {
		...mapGetters('auth', ['is_logged_in']),
		currentRoute() {
			return this.$route.name;
		},
	},
	created() {
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
			this.width = window.innerWidth;
			this.menuChange = this.width < 768;
		},
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		toRoute(obj) {
			// this.isMenuOpen = false;
			this.$router.push(obj);
		},
		setNewUiflag(v) {
			this.isNewUi = v;
		},
	},
};
</script>
